import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { listSpecialities } from "api/patientHistoryMaster";
import PatientHistoryTab from "./PatientHistoryTab";
import { PATIENT_HISTORY_MASTERS } from "./patientHistoryMasterForm";

const PatientHistoryMaster = () => {
  const [activeKey, setActiveKey] = useState(PATIENT_HISTORY_MASTERS[0].key);
  const [visited, setVisited] = useState(
    () => new Set([PATIENT_HISTORY_MASTERS[0].key])
  );
  const [specialityOptions, setSpecialityOptions] = useState([]);

  useEffect(() => {
    let active = true;
    listSpecialities()
      .then((list) => active && setSpecialityOptions(list))
      .catch(() => toast.error("Could not load specialities"));
    return () => {
      active = false;
    };
  }, []);

  const open = (key) => {
    setActiveKey(key);
    setVisited((prev) => new Set(prev).add(key));
  };

  return (
    <Box sx={{ padding: "1rem 1.5rem" }}>
      <Typography variant="h6" sx={{ fontWeight: 600, color: "#1B2559" }}>
        Patient History Master
      </Typography>

      <Box
        role="tablist"
        aria-label="Patient History Master"
        sx={{ display: "flex", alignItems: "center", mt: 1, borderBottom: "1px solid #E6EBFF" }}
      >
        {PATIENT_HISTORY_MASTERS.map((master) => (
          <Box
            key={master.key}
            component="button"
            type="button"
            role="tab"
            aria-selected={activeKey === master.key}
            onClick={() => open(master.key)}
            sx={{
              border: "none",
              background: "transparent",
              borderBottom:
                activeKey === master.key ? "2px solid #194AF5" : "2px solid transparent",
              color: activeKey === master.key ? "#194AF5" : "#7D8DC4",
              padding: "0.5rem 1rem",
              fontWeight: 600,
              fontSize: "0.875rem",
              cursor: "pointer",
            }}
          >
            {master.label}
          </Box>
        ))}
      </Box>

      {PATIENT_HISTORY_MASTERS.filter((master) => visited.has(master.key)).map((master) => (
        <Box
          key={master.key}
          role="tabpanel"
          aria-label={master.label}
          hidden={activeKey !== master.key}
        >
          <PatientHistoryTab master={master} specialityOptions={specialityOptions} />
        </Box>
      ))}
    </Box>
  );
};

export default PatientHistoryMaster;
